var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "readmore" },
    [
      _c("p", { staticClass: "position-relative mb-0" }, [
        _vm._v(_vm._s(_vm.displayedContent)),
        _vm.isCollapsed && this.content != undefined
          ? _c(
              "span",
              {
                staticClass: "d-inline-block pl-1 clickable text-brand-medium",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.toggleContent.apply(null, arguments)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.t.general_ReadMore))]
            )
          : _vm._e(),
      ]),
      _vm.isCollapsed === false ? _vm._t("default") : _vm._e(),
      !_vm.isCollapsed && this.content != undefined
        ? _c(
            "span",
            {
              staticClass: "d-inline-block clickable text-brand-medium",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.toggleContent(_vm.charactersToShow)
                },
              },
            },
            [_vm._v(_vm._s(_vm.t.general_ReadLess))]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }